import { motion } from "framer-motion";

export const SectionTitle = ({ eyebrow, title, subtitle, light = false }) => (
  <div className="max-w-2xl">
    {eyebrow && (
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.5 }}
        className="text-brand-gold uppercase tracking-[0.3em] text-xs mb-4"
      >
        {eyebrow}
      </motion.p>
    )}
    <motion.h2
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay: 0.1 }}
      className={`font-display text-3xl lg:text-4xl font-bold leading-tight ${
        light ? "text-brand-base" : "text-brand-cream"
      }`}
    >
      {title}
    </motion.h2>
    {subtitle && (
      <motion.p
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className={`mt-4 text-base leading-relaxed ${
          light ? "text-brand-burgundy/80" : "text-brand-sand"
        }`}
      >
        {subtitle}
      </motion.p>
    )}
  </div>
);
